<template>
  <div class="ws-info-select">{{_content}}</div>
</template>

<script>
export default {
  methods: {
    $_getItemByValue(value) {
      if (this.multiple) {
        const selectedItems = this.items.filter(item => value.includes(item.value));
        return selectedItems.map(item => item.text).join();
      } else {
        return this.items.find(item => item.value == value).text;
      }
    },
  },
  computed: {
    _content() {
      return this.value == undefined || !this.items.length
        ? null
        : this.$_getItemByValue(this.value);
    },
  },
  props: {
    value: {
      type: [Number, String, Array],
      default: null,
    },
    items: {
      type: Array,
      required: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/ws-info-select.scss";
</style>